var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 5.49984H17.4165C17.6596 5.49984 17.8928 5.59641 18.0647 5.76832C18.2366 5.94023 18.3332 6.17339 18.3332 6.4165V16.4998C18.3332 16.9861 18.14 17.4524 17.7962 17.7962C17.4524 18.14 16.9861 18.3332 16.4998 18.3332M16.4998 18.3332C16.0136 18.3332 15.5473 18.14 15.2035 17.7962C14.8597 17.4524 14.6665 16.9861 14.6665 16.4998V4.58317C14.6665 4.34006 14.5699 4.1069 14.398 3.93499C14.2261 3.76308 13.993 3.6665 13.7498 3.6665H4.58317C4.34006 3.6665 4.1069 3.76308 3.93499 3.93499C3.76308 4.1069 3.6665 4.34006 3.6665 4.58317V15.5832C3.6665 16.3125 3.95624 17.012 4.47196 17.5277C4.98769 18.0434 5.68716 18.3332 6.4165 18.3332H16.4998ZM7.33317 7.33317H10.9998M7.33317 10.9998H10.9998M7.33317 14.6665H10.9998",
    stroke: "#2D2D2D",
    strokeOpacity: 0.75,
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/news-icon.ff676f8badc7fb99504acc8f9ebcd4a1.svg";
export { ForwardRef as ReactComponent };